import { Text } from '@mantine/core';
import { DetailCard, type WaRendererProps } from './primitives';

/** Shared location pin — renders in BOTH directions. It used to be gated on
 *  `incoming`, so a location the agent sent showed as bare coordinates. */
export function LocationCard({ view }: WaRendererProps) {
  const loc = view.location;
  if (!loc) return null;
  return (
    <DetailCard>
      <Text size="xs" fw={600}>
        📍 {loc.name ?? 'Shared location'}
      </Text>
      {loc.address && (
        <Text size="xs" c="dimmed" lineClamp={2}>
          {loc.address}
        </Text>
      )}
      <a
        href={`https://www.google.com/maps?q=${loc.latitude},${loc.longitude}`}
        target="_blank"
        rel="noreferrer"
        style={{ fontSize: 12, color: 'var(--mantine-color-blue-6)' }}
      >
        Open in Maps
      </a>
    </DetailCard>
  );
}
